<template>

    <div>
        <swiper :options="swiperSlider" class="gallery" ref="swiper">
            <swiper-slide v-for="(item, index) in sliderData" :key="index" class="gallery-item" @click.native="setLightboxData(sliderData, 'gallery')">
                <img alt="" :key="index" v-lazy="publicPath+item">
            </swiper-slide>

            <div class="gallery-pagination gallery-counter" slot="pagination"></div>

        </swiper>

        <div class="gallery-nav right" @click="next">

            <svg id="Backward_Arrow" data-name="Backward Arrow" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path id="Path_10" data-name="Path 10" d="M5,0,4.091.909,7.532,4.351H0v1.3H7.532L4.091,9.091,5,10l5-5Z" fill="#333"/></svg>

        </div>

        <div class="gallery-nav left" @click="prev">

            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><g id="Group_203" data-name="Group 203" transform="translate(-1431 -507)"><g id="Backward_Arrow" data-name="Backward Arrow" transform="translate(1441 517) rotate(180)"><path id="Path_10" data-name="Path 10" d="M5,0,4.091.909,7.532,4.351H0v1.3H7.532L4.091,9.091,5,10l5-5Z" fill="#333"/></g></g></svg>
        </div>

    </div>

</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Slider',
  props: {
    sliderData: {
      type: Object,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      swiperSlider: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: false,
        autoResize: false,
        watchSlidesProgress: true,
        pagination: {
          el: '.gallery-pagination',
          type: 'fraction',
          renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span><span class="sepparator">|</span><span class="sum ' + totalClass + '"></span>';
          }
        },
        breakpoints: {
          768: {
            spaceBetween: 30,
          }
        },
        // init: function () {
        //   // this.slideTo(this.slides.length - 1)
        // }
      },
    }
  },

  methods: {
    prev() {
      this.$refs.swiper.$swiper.slidePrev()
    },
    next() {
      this.$refs.swiper.$swiper.slideNext()
    },
    setLightboxData (data, type) {
      // this.bodyLock = true
      this.$emit('show-modal', data, type)
    },
  }
}
</script>

